import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { ITextProps } from '.';

export const generate = (
  props?: Partial<IComponentSchema<ITextProps>>
): IComponentSchema<ITextProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.STRING,
    name: props?.name || id,
    title: props?.title || 'Text',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.Text,
    'x-component-props': {
      text: 'Text',
      visible: true,
    },
    'x-component-props-config': {},
  };
};
